import React from "react";
import Form from "react-bootstrap/Form";

/**
 * Admin-only club table MDR and included GST percents.
 * Club managers must not render this component.
 */
const ClubTableFeeFields = ({
  t,
  values,
  errors = {},
  disabled = false,
  onFieldChange,
}) => (
  <section className="club-website-section">
    <h3 className="h5 club-website-section-title">
      {t("CLUB_TABLE_FEE_SECTION")}
    </h3>
    <div className="row g-3">
      <div className="col-md-6">
        <Form.Group controlId="club-table-mdr-percent">
          <Form.Label>
            {t("CLUB_TABLE_MDR_PERCENT")}
            <span className="text-danger" aria-hidden="true">
              {" "}
              *
            </span>
          </Form.Label>
          <Form.Control
            type="text"
            inputMode="decimal"
            value={values.tableMdrPercent ?? ""}
            placeholder="1.75"
            disabled={disabled}
            isInvalid={Boolean(errors.tableMdrPercent)}
            onChange={(e) => onFieldChange("tableMdrPercent", e.target.value)}
          />
          <Form.Text className="text-muted">
            {t("CLUB_TABLE_MDR_PERCENT_HELP")}
          </Form.Text>
          <Form.Control.Feedback type="invalid">
            {errors.tableMdrPercent}
          </Form.Control.Feedback>
        </Form.Group>
      </div>
      <div className="col-md-6">
        <Form.Group controlId="club-table-gst-percent">
          <Form.Label>
            {t("CLUB_TABLE_GST_PERCENT")}
            <span className="text-danger" aria-hidden="true">
              {" "}
              *
            </span>
          </Form.Label>
          <Form.Control
            type="text"
            inputMode="decimal"
            value={values.tableGstPercent ?? ""}
            placeholder="5"
            disabled={disabled}
            isInvalid={Boolean(errors.tableGstPercent)}
            onChange={(e) => onFieldChange("tableGstPercent", e.target.value)}
          />
          <Form.Text className="text-muted">
            {t("CLUB_TABLE_GST_PERCENT_HELP")}
          </Form.Text>
          <Form.Control.Feedback type="invalid">
            {errors.tableGstPercent}
          </Form.Control.Feedback>
        </Form.Group>
      </div>
    </div>
  </section>
);

export default ClubTableFeeFields;
